import React from "react";
import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import DateUtils from "../DateUtils";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import jwtClient from "../JwtClient";

export default class StatusList extends React.Component {
    state = {
        statuses: [],
        total: 0,
        next: '',
        previous: '',
        error: '',
    };

    render() {
        if (this.state.error) {
            return <Alert variant="danger">{this.state.error}</Alert>
        }
        return (
            <div>
                <Row className="mx-0">
                    <h2 className="mt-4">Statuses (01-001 or 01-002)</h2>
                </Row>
                <span>Total: {this.state.total}</span>

                <Table>
                    <thead>
                    <tr>
                        <th>Created</th>
                        <th>Track</th>
                        <th>Code</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.statuses.map((s, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{DateUtils.toLocalDateString(s.created_at)}</td>
                                        <td>{s.track}</td>
                                        <td>{s.code}</td>
                                        <td>{s.status}</td>
                                    </tr>
                                )
                            }
                        )
                    }
                    </tbody>
                </Table>

                <Row>
                    <Col className="col-6">
                        {this.state.previous &&
                            <Button onClick={() => this.loadStatuses(this.state.previous)}>&lt; Previous</Button>
                        }
                    </Col>
                    <Col className="col-6 text-right">
                        {this.state.next &&
                            <Button onClick={() => this.loadStatuses(this.state.next)}>&gt; Next</Button>
                        }
                    </Col>
                </Row>
            </div>
        )
    }

    componentDidMount() {
        this.loadStatuses('/api/v1/status/list');
    }

    loadStatuses = url => {
        jwtClient.get(url)
            .then(response => {
                const data = response.data;
                this.setState({
                    statuses: data.results,
                    total: data.count,
                    next: data.next,
                    previous: data.previous,
                });
            })
            .catch(() => {
                this.setState({error: 'The service has responded with an error! Contact the administrators to resolve the issue!'});
            })
    }
}
